<template>
  <v-dialog
    v-model="isOpen"
    max-width="790"
    width="530"
    :persistent="true"
    @keydown.prevent.enter="executeMainAction"
  >
    <v-card class="dialog-box">
      <v-card-title class="headline">
        {{ $t("NoTechnicalPointDetected") }}
      </v-card-title>

      <v-card-text style="padding-bottom: 10px; white-space: normal">
        <div style="padding-bottom: 10px">
          {{ $t("ClosureWithoutTechnicalPointConfirmation") }}
        </div>
        <div>{{ $t("AutomaticTechnicalPointCreation") }}</div>
      </v-card-text>
      <treeselect
        v-model="technicalPoint"
        :options="technicalPointOptions"
        class="select-tech-point ml-4"
        :clearable="false"
      />

      <v-card-actions>
        <v-btn
          @click="executeSecondaryAction"
          :ripple="false"
          class="secondary-button"
          text
        >
          {{ $t("No") }}
        </v-btn>
        <v-btn
          @click="executeMainAction"
          :ripple="false"
          class="main-button"
          text
        >
          {{ $t("Yes") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "DialogClosureWithoutTechnicalPoint",

  props: {
    /**
     * Defines if the dialog box is open or not.
     */
    open: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      isOpen: false,
      technicalPoint: "A"
    };
  },

  computed: {
    technicalPointOptions() {
      return [
        {
          label: this.$i18n.tc("Pole", 1),
          id: "A"
        },
        {
          label: this.$i18n.tc("Manhole", 1),
          id: "C"
        },
        {
          label: this.$i18n.tc("Cabinet", 1),
          id: "B"
        },
        {
          label: this.$i18n.tc("Virtual", 1),
          id: "V"
        },
        {
          label: this.$i18n.tc("TobyBox", 1),
          id: "T"
        },
      ];
    }
  },

  watch: {
    open(newValue) {
      this.isOpen = newValue;
    }
  },

  methods: {
    ...mapActions(["setClosureWithoutTechPoint"]),
    /**
     * Send an event to the parent to execute the main action.
     */
    executeMainAction() {
      this.setClosureWithoutTechPoint(this.technicalPoint);
      this.$emit("mainAction");
    },
    /**
     * Send an event to the parent to execute the secondary action.
     */
    executeSecondaryAction() {
      this.$emit("secondaryAction");
    }
  }
};
</script>

<style scoped>
.select-tech-point {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 11px;
  text-align: left;
  margin-bottom: 20px;
  padding-left: 8px;
  position: relative;
}

.v-dialog__content >>> .v-dialog {
  overflow-y: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Dialog/DialogClosureWithoutTechnicalPoint.vue